var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInactiveGridView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1671 11.25H6.42787V6.75H11.1671V11.25ZM4.84813 11.25H0.108887V6.75H4.84813V11.25ZM11.1671 5.25H6.42787V0.75H11.1671V5.25ZM4.84813 5.25H0.108887V0.75H4.84813V5.25Z",
    fill: "#3CB4E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveGridView);
export default __webpack_public_path__ + "static/media/inactiveGridView.e00e75990e7b91ea477db72cc0ae7c08.svg";
export { ForwardRef as ReactComponent };